export interface SkipConfig {
  enabled: boolean;
  introSegments: string[];
  questionSegments: number[];
}

export const skipConfig: SkipConfig = {
  enabled: true,
  introSegments: ['SEGMENT_3'],
  questionSegments: [5, 9],
};

export const isSkippableIntroSegment = (segment: string): boolean => {
  return skipConfig.enabled && skipConfig.introSegments.includes(segment);
};

export const isSkippableQuestionSegment = (segmentIndex: number): boolean => {
  return skipConfig.enabled && skipConfig.questionSegments.includes(segmentIndex);
};
